'use strict';

var assetColors = {};

exports.__exports = assetColors;
//# sourceMappingURL=assetColors.cjs.map
